import react, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectReportsResults, selectCurrentFailureReportSubtitle, selectCurrentFailureReportTitle } from '../../store/features/transmissionSlice';
import AlStarReportTable from './AlStarReportTable';
import { Typography } from '@mui/material';

const ErrorsTable = () => {
    const [visibleColumns, setVisibleColumns] = useState<string[]>([]);
    const reportResults = useSelector(selectReportsResults);
    const failReportColumns = reportResults?.alstar_record?.[0] || [];
    // const currentFailureReportSubtitle = useSelector(selectCurrentFailureReportSubtitle);
    const currentFailureReportTitle = useSelector(selectCurrentFailureReportTitle);

    useEffect(() => {
        if (reportResults?.alstar_record) {
            const excludedColumns = ['operator', 'index', 'type', 'tag', 'units'];
            const visibleColumnIds = failReportColumns
                .map((column: any, colIndex: number) => ({
                    id: `alstar_record_${colIndex}`,
                    label: column
                }))
                .filter((col: any) => !excludedColumns.some(excluded =>
                    col.label.toLowerCase().includes(excluded.toLowerCase())
                ))
                .map((col: any) => col.id);

            setVisibleColumns(visibleColumnIds);
        }
    }, [reportResults]);

    if (reportResults?.alstar_record)
        return (<AlStarReportTable
            columns={reportResults.alstar_record?.length > 0 ? reportResults.alstar_record?.[0].map((column: any, colIndex: number) => ({
                id: `alstar_record_${colIndex}`,
                label: column,
                    minWidth: 100,
                    align: 'left'
                }))
                : []}
            data={reportResults.alstar_record?.slice(1).filter((row: any) => row[0] === currentFailureReportTitle)}
            visibleColumns={visibleColumns}
            onVisibleColumnsChange={setVisibleColumns}
        />)
    return <></>
}

export default ErrorsTable;
